import { connect } from 'react-redux';
import { track } from 'ha/modules/Analytics/actions';

import HubspotForm from '../components/HubspotForm';

export default connect(
  null,
  {
    track,
  },
)(HubspotForm);
